export default "__VITE_ASSET__DlAAiXpX__"